import styled from '@emotion/styled';
import {mixinOverflowY, mixinSVGIcon} from 'webapp-lib/styling';

export const StyledPreview = styled.div`
  ${mixinOverflowY};
  overflow-x: hidden;
  padding: var(--gutter) 200px 0;

  .thumbnail {
    position: relative;
    width: fit-content;
    margin-bottom: var(--gutter-tiny);

    .PdfViewer {
      padding: 0;
      margin: 0;
    }
  }
`;

export const StyledWarning = styled.div`
  display: flex;
  color: var(--color-alerts-error);
  justify-content: center;
  align-items: center;
  padding: var(--gutter-small);
  margin-top: var(--gutter-small);
  gap: var(--gutter-little);

  svg {
    ${mixinSVGIcon}
  }
`;
